import { get } from 'lodash';
import { REFERRAL_INBOUND, REFERRAL_OUTBOUND } from 'embeds/components/ReferralsHeader';
import { isEnvironment } from './getEnvironment';

export const outreachSingular = 'outreach';

export const outreachPlural = 'outreaches';

export const isUsingOutreachExperience = (settings: Record<string, unknown>) =>
  get(settings, 'referral.useOutreachExperience.enabled', false);

export const getReferralType = () => {
  const path = window.location.pathname.replace(/\//, '');
  const isInboundReferral = (path.includes('referral') || path.includes('outreach')) && !path.includes('outbound');
  return isInboundReferral ? REFERRAL_INBOUND : REFERRAL_OUTBOUND;
};

export const isOnOutreachExperience = (settings: Record<string, unknown>) =>
  isUsingOutreachExperience(settings) && !isEnvironment('chc') && getReferralType() !== REFERRAL_OUTBOUND;
